export default {
  not_set_up: {
    title: 'Las reservas aún no están configuradas para esta ubicación',
    description:
      'Una ubicación recibe reservas una vez que está vinculada a su ficha de Google y tiene un propietario. Si el restaurante aún no tiene propietario, añade uno en Equipo. Hasta entonces no hay horarios de reservas que editar aquí, y los cambios en los horarios de Online Shop no se copian a Reservas.',
  },
  company_not_loaded: {
    title: 'No se pudo cargar la configuración de reservas',
    description:
      'No se pudo cargar la configuración de reservas de este local, por lo que ahora no se puede editar su horario de reservas. Inténtalo de nuevo.',
    retry: 'Reintentar',
  },
};
